import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { usePopup } from './PopupProvider';

export const useError = () => {
  const { t } = useTranslation();
  const { showErrorPopover } = usePopup();

  const handleError = (e: AxiosError, message?: string, map?: Map<number, string>) => {
    showErrorPopover(processAxiosError(e, message, map));
  };

  const errorMessage = (message?: string) => {
    showErrorPopover(message || t('error.generic'));
  };

  const processAxiosError = (axiosError: AxiosError, message?: string, map?: Map<number, string>): string => {
    const errorStatus = axiosError.response?.status;

    if (errorStatus === 401) {
      return t('error.unauthenticated');
    }

    if (errorStatus && map) {
      return map.get(errorStatus) || message || t('error.generic');
    }

    return message || t('error.generic');
  };

  return { handleError, errorMessage };
};
